import ActionTypes from '../actions/actionTypes';

const initialState = {
  isLoading: false,
  notificationsList: [],
  isError: false,
  markReadLoading: false, 
  markReadSuccess: false,
  markReadError: false,
};

export function notificationsReducer(state = initialState, { type, payload }) {
  let notifications;
  switch (type) {
    case ActionTypes.NOTIFICATIONS.FETCH.REQUEST:
      return {
        ...state,
        isLoading: true,
        isError: false,
      };
    case ActionTypes.NOTIFICATIONS.FETCH.SUCCESS:
      notifications = payload.notifications;
      return {
        ...state,
        isLoading: false,
        notificationsList: notifications,
      };
    case ActionTypes.NOTIFICATIONS.FETCH.FAILURE:
      return {
        ...state,
        isLoading: false,
        isError: true,
      };
    case ActionTypes.NOTIFICATIONS.MARK_AS_READ.REQUEST:
      return {
        ...state,
        markReadLoading: true,
        markReadSuccess: false,
        isError: false,
      };
    case ActionTypes.NOTIFICATIONS.MARK_AS_READ.SUCCESS:
      return {
        ...state,
        markReadLoading: false,
        markReadSuccess: true,
        notificationsList: state.notificationsList.map(item => 
          item.id === payload.notificationId ? { ...item, isRead: true } : item
        )
      };
    case ActionTypes.NOTIFICATIONS.MARK_AS_READ.FAILURE:
      return {
        ...state,
        markReadLoading: false,
        markReadError: true,
      };
    default:
      return state;
  }
}
